import { render, staticRenderFns } from "./switchSubject.vue?vue&type=template&id=4b8c52c4&scoped=true"
import script from "./switchSubject.vue?vue&type=script&lang=js"
export * from "./switchSubject.vue?vue&type=script&lang=js"
import style0 from "./switchSubject.vue?vue&type=style&index=0&id=4b8c52c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c52c4",
  null
  
)

export default component.exports